import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'

type Pagination = {
  totalPages?: number
  currentPage: number
}

const initialState: Pagination = { currentPage: 1 }
const paginationSlice = createSlice({
  name: 'pagination',
  initialState,
  reducers: {
    setCurrentPage: (state, { payload }: PayloadAction<number>) => {
      state.currentPage = payload
    },
    setTotalPages: (state, { payload }: PayloadAction<number>) => {
      state.totalPages = payload
    },
  },
})

export const { setCurrentPage, setTotalPages } = paginationSlice.actions

export const selectCurrentPage = (state: RootState) =>
  state.pagination.currentPage
export const selectTotalPages = (state: RootState) =>
  state.pagination.totalPages

export default paginationSlice
